module.exports = __webpack_public_path__ + "img/menu-hulianwang-active.1c642839.svg";